import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from './administratorAddContainerActions'
import AdministratorAdd from './AdministratorAdd'
import SuccessCheckMessage from '../../../../common/SuccessCheckMessage'
import SubmitSpinner from '../../../../common/Spinners/SubmitSpinner'

class AdministratorAddContainer extends React.Component {
  static propTypes = {
    submitAdministrator: PropTypes.bool.isRequired,
    submittingAdministrator: PropTypes.bool.isRequired,
    submittedAdministrator: PropTypes.bool.isRequired,
    administrator: PropTypes.object.isRequired,

    isInvalid: PropTypes.object,

    resetPasswordSent: PropTypes.bool.isRequired,

    setAdminFirstName: PropTypes.func.isRequired,
    setAdminLastName: PropTypes.func.isRequired,
    setAdminEmailAddress: PropTypes.func.isRequired,
    submitAdmin: PropTypes.func.isRequired,
    submitNewAdmin: PropTypes.func.isRequired
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.submitAdministrator && this.props.submitAdministrator) {
      this.props.submitNewAdmin(this.props.administrator)
    }
  }

   getFormValidity = () => {
    const { isInvalid = {}, administrator = {} } = this.props

    const emailValid =
      administrator.emailAddress &&
      !isInvalid.emailAddress?.isInvalid

    const firstNameValid =
      administrator.firstName &&
      !isInvalid.firstName?.isInvalid

    const lastNameValid =
      administrator.lastName &&
      !isInvalid.lastName?.isInvalid

    return emailValid && firstNameValid && lastNameValid
  }

  render () {
    const successMessage = 'Administrator added and can now reset their password'

    const formIsValid = this.getFormValidity()

    return (
      <AdministratorAdd
        administrator={this.props.administrator}
        isInvalid={{
          ...this.props.isInvalid,
          formIsValid
        }}
        setFirstName={this.props.setAdminFirstName}
        setLastName={this.props.setAdminLastName}
        setEmailAddress={this.props.setAdminEmailAddress}
        submit={this.props.submitAdmin}
        submitting={this.props.submittingAdministrator}
      >
        {this.props.submittingAdministrator && <SubmitSpinner />}
        {this.props.resetPasswordSent && (
          <SuccessCheckMessage message={successMessage} />
        )}
      </AdministratorAdd>
    )
  }
}

const mapStateToProps = ({ administratorAdd }) => {
  return {
    submitAdministrator: administratorAdd.submitAdministrator,
    submittingAdministrator: administratorAdd.submittingAdministrator,
    submittedAdministrator: administratorAdd.submittedAdministrator,
    administrator: administratorAdd.administrator || {},
    isInvalid: administratorAdd.isInvalid || {},
    resetPasswordSent: administratorAdd.resetPasswordSent
  }
}

const mapDispatchToProps = (dispatch) => {
  const { setting, submit } = actions
  return bindActionCreators({
    setAdminFirstName: setting.firstName,
    setAdminLastName: setting.lastName,
    setAdminEmailAddress: setting.emailAddress,
    submitAdmin: submit.administrator,
    submitNewAdmin: submit.newAdministrator
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdministratorAddContainer)
